<template>
  <div>
    <page-header title="ویرایش کاربر"></page-header>

    <crud-generator v-if="customer" :fields="fields" @submit="submit" :current-values="customer" name="customers"></crud-generator>
  </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import CrudGenerator from "@/components/General/CrudGenerator";

export default {
  name: "UpdateCustomer",

  components: {CrudGenerator, PageHeader},

  data() {
    return {
      fields: [],
      customer: null,
    }
  },

  mounted() {
    this.getCustomer()
  },

  methods: {
    getCustomer() {
      this.$store.dispatch("singleCustomer", this.$route.params.id)
      .then((res) => {
        this.customer = res.data
        this.fillFields()
      })
    },

    fillFields() {
      this.fields = [
        {
          name: 'name',
          label: 'نام',
          cols: 6,
          type: 'text',
          direction: 'rtl',
        },
        {
          name: 'phone_number',
          label: 'شماره موبایل',
          cols: 6,
          type: 'text',
          direction: 'ltr',
        },
      ]
    },

    submit(values) {
      this.$store.dispatch("updateCustomer", {data: values, identifier: this.$route.params.id})
          .then(() => {
            this.$router.push('/customers');
          })
    },
  }
}
</script>

<style scoped>

</style>